import { useContext } from 'react'
import {
  CustomerDetailContext,
  type CustomerDetailContextValue,
} from '../context/CustomerDetailContext'

// Standard "consume context or throw" pattern — every tab/card in the
// profile funnels through this so the missing-provider failure message is
// loud and consistent. Mirrors `useCustomerContext`.

export const useCustomerDetailContext = (): CustomerDetailContextValue => {
  const ctx = useContext(CustomerDetailContext)
  if (!ctx) {
    throw new Error(
      'useCustomerDetailContext must be used inside <CustomerDetailProvider>. ' +
        'Wrap the consumer with <CustomerDetailProvider> or render <CustomerDetailPage>.',
    )
  }
  return ctx
}
